import { memo } from 'react'
import { Box } from '@mui/material'

const CardGridLayout = ({ children }) => {
  return (
    <Box
      sx={{
        gap: 3,
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(4, 1fr)'
        }
      }}
    >
      {children}
    </Box>
  )
}

export default memo(CardGridLayout)
